import { ItemID } from "types/common";

import { defaultTimeToLive } from "consts";

import { useGetTaxonomyItemByClassAndId } from "./useGetTaxonomyItemByClassAndId";

export const useGetTaxonomyItemByClassAndIdWithCache = (itemId: ItemID, relationsKeysToExpand?: string[]) => {
  return useGetTaxonomyItemByClassAndId(itemId, relationsKeysToExpand, defaultTimeToLive);
}
